var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeacherRead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 4.40234,
    r: 2.5,
    stroke: "#026094"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41682 13.8461C1.81651 13.4778 1.5 12.7638 1.5 11.9526L1.5 9.90234C1.5 8.66601 2.80108 7.8619 3.90689 8.4148L4.59605 8.75939C5.47986 9.20129 6.52014 9.20129 7.40395 8.75939L8.09311 8.41481C9.19892 7.8619 10.5 8.66601 10.5 9.90234L10.5 11.9526C10.5 12.7638 10.1835 13.4778 9.58318 13.8461C8.75359 14.355 7.50909 14.9023 6 14.9023C4.49091 14.9023 3.24641 14.355 2.41682 13.8461Z",
    stroke: "#026094"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.40234H15",
    stroke: "#3AC47D",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.40234H14",
    stroke: "#3AC47D",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.40234H14",
    stroke: "#3AC47D",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacherRead);
export default __webpack_public_path__ + "static/media/teacher-read.527eb641a3cc0238185ebce3a29d5ea9.svg";
export { ForwardRef as ReactComponent };